export default "__VITE_ASSET__ae7b6afa__"